import React, { useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Input } from '../Input/Input';
import { SearchSelect } from '../SearchSelect/SearchSelect';
import { countries } from '../../lib/utils/defaults';

const countryToCurrencyMap = (country: string) => {
	switch (country) {
		case 'US':
			return 'USD';
		case 'AT':
		case 'BE':
		case 'BG':
		case 'HR':
		case 'CY':
		case 'DK':
		case 'FI':
		case 'EE':
		case 'FR':
		case 'DE':
		case 'GR':
		case 'HU':
		case 'IE':
		case 'LV':
		case 'IT':
		case 'LT':
		case 'LU':
		case 'MT':
		case 'NL':
		case 'PT':
		case 'SK':
		case 'SI':
		case 'ES':
		case 'PL':
		case 'RO':
		case 'SE':
			return 'EUR';
		default:
			return 'GBP';
	}
};

export default function Two() {
	const { errors, control, watch, setValue } = useFormContext();
	const [showCurrency, setShowCurrency] = useState(false);
	const country = watch('companyCountry');
	const currency = watch('currency');

	const countryCurrency = countryToCurrencyMap(country);
	const differentCurrency = countryCurrency !== currency;

	return (
		<div className='flex flex-col gap-4'>
			<h1 className='text-3xl my-4 leading-tight font-light'>
				Tell us about your company.
			</h1>
			<Controller
				name='companyName'
				control={control}
				rules={{
					required: 'Please enter your company name',
				}}
				render={props => {
					return (
						<Input
							type='text'
							onChange={props.onChange}
							nullable={false}
							error={errors?.companyName?.message}
							label="What's the name of your company?"
							value={props.value}
							name='companyName'
							placeholder='Example Company'
							required
						/>
					);
				}}
			/>
			<Controller
				name='companyCountry'
				control={control}
				rules={{
					required: 'Please select a country',
				}}
				render={props => (
					<SearchSelect
						label='Where are you located?'
						onChange={value => {
							if (Array.isArray(value) || !value?.value) return;
							props.onChange(value?.value);
							setValue('currency', countryToCurrencyMap(value?.value));
						}}
						name='companyCountry'
						options={countries}
						placeholder='United Kingdom'
						value={props.value}
						error={errors?.companyCountry?.message}
						isPortalled={false}
						required
						isClearable={false}
					/>
				)}
			/>
			<p className='my-2'>
				We have assumed your currency is{' '}
				<strong>{differentCurrency ? currency : countryCurrency}</strong>, if
				this is incorrect,{' '}
				<button
					className='link'
					type='button'
					onClick={() => setShowCurrency(!showCurrency)}
				>
					click here
				</button>
				.
			</p>
			{showCurrency && (
				<Controller
					name='currency'
					control={control}
					rules={{
						required: 'Please select a currency',
					}}
					render={props => (
						<SearchSelect
							label='Which currency would you like to be billed in?'
							onChange={value => {
								if (Array.isArray(value)) return;
								props.onChange(value?.value);
							}}
							name='currency'
							options={[
								{ label: 'GBP - British Pound Sterling', value: 'GBP' },
								{ label: 'USD - United States Dollar', value: 'USD' },
								{ label: 'EUR - Euro', value: 'EUR' },
							]}
							placeholder='Please select a currency'
							value={props.value}
							error={errors?.currency?.message}
							isPortalled={false}
							required
							isClearable={false}
						/>
					)}
				/>
			)}
		</div>
	);
}
